import { JsonObject } from 'json2typescript';
import { ActivitiesResponseInterface } from '../interfaces/activities-response.interface';
import { ActivityTypeResponseModel } from './activitytype-response.model';

@JsonObject('ActivitiesResponseModel')
export class ActivitiesResponseModel implements ActivitiesResponseInterface {
  ActionIdOrders?: string;
  ActivityId?: string;
  AmountExecuted?: number;
  CalculatedFee?: string;
  CashoutTotal?: Boolean;
  CompletedDescription?: string;
  CreatedDate?: string;
  Currency?: string;
  Description?: string;
  EndDate?: string;
  FinalValue?: number;
  InflowCashoutValue?: number;
  ModuleOrders?: string;
  PdfProposalFile?: string;
  PortfolioCode?: string;
  ProposalDeleted?: Boolean;
  ProposalDeletedDate?: string;
  ProposalStateId?: string;
  ProposalStateName?: string;
  ProposalUniqueIdentifier?: string;
  Status?: string;
  StatusDescription?: string;
  Type?:ActivityTypeResponseModel;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
